import React from "react";

import "../styles/Intro.css";
import Typist from "react-typist";
import "react-typist/dist/Typist.css";
import { FaDiscord } from "react-icons/fa";
import FadeInSection from "./FadeInSection";
import ParticlePortrait from "./ParticlePortrait";

class Intro extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1",
      visible: true,
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey,
    });
  }
  render() {
    return (
      <div id="intro">
        <div className="intro-simulation">
          <ParticlePortrait />
        </div>
        <div className="intro-block">
          <Typist avgTypingDelay={120}>
            <span className="intro-title">
              {"hi, "}
              <span className="intro-name">{"shy"}</span>
              {" here."}
            </span>
          </Typist>
          <FadeInSection>
            <div className="intro-desc">I am a Junior Software Engineer based in Estonia with
               a passion for building impactful products and a proven track record of supporting
                others on development projects. As a lifelong learner, I stay curious and driven to 
                solve new challenges every day.</div>
            <a
              // href="https://discord.gg/nRu95bDxzu"
              className="intro-contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaDiscord style={{ fontSize: 22 }} />
              {" Join community!"}
            </a>
          </FadeInSection>
        </div>
      </div>
    );
  }
}

export default Intro;
